import React, { useState } from 'react';
import "./FAQSection.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';


const FAQSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleFAQ = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? -1 : index));
    };

    const faqs = [
        {
            question: "How quickly will I receive my report?",
            answer: "Most reports are generated within 5-10 minutes after payment confirmation. You'll receive an email notification when your report is ready for download."
        },
        {
            question: "Can I get a refund if I'm not satisfied?",
            answer: "Yes, we offer a 30-day money-back guarantee. If you're not satisfied with your report, simply contact our support team within 30 days of purchase for a full refund."
        },
        {
            question: "Do you provide visa application assistance?",
            answer: "We provide comprehensive visa application guidance and support, including document checklists and tips for a successful application. However, we do not submit applications on your behalf."
        },
        {
            question: "Is my personal information secure?",
            answer: "Absolutely. We use industry-standard encryption and security measures to protect your personal information. Your data is never shared with third parties without your consent."
        },
        {
            question: "What makes your AI recommendations different?",
            answer: "Our AI system analyzes thousands of data points to provide personalized visa recommendations based on your unique profile and travel history. This ensures you receive the most relevant and accurate advice for your visa application."
        },
        {
            question: "Can I update my information after submitting?",
            answer: "Yes, you can update your information at any time before you generate your report. Simply log in to your account, navigate to your profile, and make the necessary changes."
        }
    ];

    return (
        <section className="faq-section">
            <div className="faq-container">
                <div className="section-headder">
                    <div className="section-badge">Quick Answers</div>
                    <h2 className="section-title">Frequently Asked Questions</h2>
                    <p className="section-description">
                        Everything you need to know about our services and process
                    </p>
                </div>
                <div className="faq-container">
                    {faqs.map((faq, index) => (
                        <div className={`faq-item ${activeIndex === index ? 'active' : ''}`} key={index}>
                            <button className="faq-question" onClick={() => toggleFAQ(index)}>
                                <span>{faq.question}</span>
                                <span className="faq-icon">
                                    <FontAwesomeIcon icon={activeIndex === index ? faAngleUp : faAngleDown} />
                                </span>
                            </button>
                            <div
                                className={`faq-answer ${activeIndex === index ? 'active' : ''}`}
                                style={{
                                    maxHeight: activeIndex === index ? `${document.getElementById(`answer-${index}`)?.scrollHeight}px` : '0px'
                                }}
                            >
                                <div
                                    className="faq-answer-content"
                                    id={`answer-${index}`}
                                >
                                    {faq.answer}
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
